module.exports = __webpack_public_path__ + "img/home-commitment.65ba049e.svg";